import React from "react";
import "../assets/css/Footer.css";
import { Icon } from "@iconify/react";
import logo from "../assets/images/logo-footer.png";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="text-gray-600 body-font bg-1D2939">
      <div className="container  px-6 pt-24 pb-10 mx-auto">
        <div className="flex sm:flex-row flex-col md:text-left text-center order-first justify-between w-full mx-4">
          <div>
            <a href="/" className="text-gray-600 hover:text-gray-800">
              <img
                src={logo}
                alt="spandan"
                className="w-40 mx-auto md:mr-auto md:ml-0"
              />
            </a>
            <p className="py-2 pl-1 text-gray-300">
              A step by step approach to being a more humane leader
            </p>
          </div>
          <nav className="list-none text-white">
            <ul className="py-5">
              <li className="inline-block mr-8">
                <p
                  onClick={() => (window.location.href = "/")}
                  className="hover:text-gray-300 cursor-pointer"
                >
                  Home
                </p>
              </li>
              <li className="inline-block mr-8">
                <p
                  onClick={() => window.location.replace("/#events")}
                  className="hover:text-gray-300 cursor-pointer"
                >
                  All Events
                </p>
              </li>
              <li className="inline-block mr-8">
                <Link
                  to="/contact"
                  className="hover:text-gray-300 cursor-pointer"
                >
                  Contact Us
                </Link>
              </li>
              <li className="inline-block mr-8">
                <p
                  onClick={() => window.location.replace("/#events")}
                  className="hover:text-gray-300 cursor-pointer"
                >
                  Register Now
                </p>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className="container px-5 py-10 mx-auto border-475467 border-t-2 flex items-center sm:flex-row flex-col">
        <p className="text-md text-98A2B3 sm:ml-6 sm:mt-0 mt-4">
          © 2022 Spandan. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
